import { combineReducers } from 'redux'
import intel from './intel'
import prediction from './prediction'
import risk from './risk'

const reducer = combineReducers({
  intel,
  prediction,
  risk
})

export default reducer
